import { useEffect } from "react";
import { BackHeaderCoverage } from "../components/GetRecommendations/CoverageYear";
import Connector from "../components/GetRecommendations/Connector.component";
import { DoctorsPart } from "../components/GetRecommendations/Doctors";
import ScrollToTopOnRouteChange from "../shared/ScrollToTop.function";
import { useUpdateBreadcrumbs } from "../shared/updateBreadcrumbs.hook";
import clearPlanDoctorsFromSessionStorage from "../functions/clearDoctors.function";
import { useSessionStorage } from "@uidotdev/usehooks";
import { useLocation } from "react-router-dom";
import { useZipRootLoaderData } from "../hooks/useZipRootLoaderData";

const Preferences = () => {
  useUpdateBreadcrumbs("Get Recommendations");
  const location = useLocation();
  const { plans: allPlans } = useZipRootLoaderData();
  const [, setComparePlans] = useSessionStorage("dataArray", []);

  useEffect(() => {
    setComparePlans([]);
  }, []);

  useEffect(() => {
    clearPlanDoctorsFromSessionStorage();
  }, [location.pathname]);

  const activeStep = 3;
  const plansLength = allPlans.Plans.length;

  return (
    <div>
      <ScrollToTopOnRouteChange />
      <BackHeaderCoverage
        plansLength={plansLength}
        planData={allPlans.Plans[0]}
        showLink={false}
      />
      <Connector activeStep={activeStep} />
      <DoctorsPart />
    </div>
  );
};

export default Preferences;
